module.exports = __webpack_public_path__ + "assets/images/spor_fm_tv2_logo.0c30a8a86f28de958b2637a8d50a7cf8.png";